import { render, staticRenderFns } from "./EsManualMatchEdit.vue?vue&type=template&id=ec1f4e54&scoped=true&"
import script from "./EsManualMatchEdit.vue?vue&type=script&lang=js&"
export * from "./EsManualMatchEdit.vue?vue&type=script&lang=js&"
import style0 from "./EsManualMatchEdit.vue?vue&type=style&index=0&id=ec1f4e54&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec1f4e54",
  null
  
)

export default component.exports